<div class="grid-2" style="grid-template-columns: 300px 1fr;">
  <div class="card">
    <div class="card-title">Priority Groups</div>
    <div id="commentGroupsList">
      <div *ngFor="let g of groups" (click)="selectGroup(g)"
        style="padding: 12px; border-left: 4px solid; margin-bottom: 8px; cursor: pointer; border-radius: 4px; background: #f8fafc;"
        [style.borderLeftColor]="g.color" [style.background]="selectedGroup === g ? '#fdf2f5' : '#f8fafc'">
        <div style="font-weight:600; font-size: 14px;">{{g.name}}</div>
        <div style="font-size:11px; color:var(--text-muted)">{{g.items.length}} molecules</div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-title">Group Molecules: <span style="color:var(--primary)">{{selectedGroup ?
        selectedGroup.name : 'None'}}</span></div>
    <div class="table-wrap">
      <table *ngIf="selectedGroup">
        <thead>
          <tr>
            <th>Molecule</th>
            <th>NDC</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let it of selectedGroup.items">
            <td>{{it.name}}</td>
            <td>{{it.ndc || 'N/A'}}</td>
            <td><button (click)="removeFromGroup(selectedGroup, it)"
                style="color:var(--r); cursor:pointer; background:none; border:none; font-weight: 600;">Remove</button>
            </td>
          </tr>
        </tbody>
      </table>
      <p *ngIf="!selectedGroup" style="color:var(--text-muted); text-align:center; padding:40px;">Select a group
        to view molecules</p>
    </div>
  </div>
</div>
